import type { DocumentGroup } from "services/document-group-api";

/**
 * find document group that contains the given page number
 */
export const getDocumentGroupForPage = (
  pageNum: number,
  documentGroups: DocumentGroup[],
): DocumentGroup | null => {
  return (
    documentGroups.find(
      (group) => pageNum >= group.start_pg && pageNum <= group.end_pg,
    ) || null
  );
};

/**
 * format selected pages into readable text
 * examples: "Page 5 selected" or "Pages 3-8 selected"
 */
export const formatSelectionText = (selectedPages: Set<number>): string => {
  if (selectedPages.size === 0) return "";

  const sortedPages = Array.from(selectedPages).sort((a, b) => a - b);
  const firstPage = sortedPages[0];
  const lastPage = sortedPages[sortedPages.length - 1];

  if (firstPage === lastPage) {
    return `Page ${firstPage} selected`;
  }

  return `Pages ${firstPage}-${lastPage} selected`;
};

/**
 * build className string for thumbnail item based on state
 */
export const getThumbnailItemClassName = (states: {
  isActive: boolean;
  isSelected: boolean;
  isFocused: boolean;
  isDeleted: boolean;
  disabled: boolean;
}): string => {
  const classes = ["metadoc-page-thumbnails__item"];

  if (states.isActive) classes.push("metadoc-page-thumbnails__item--active");
  if (states.isSelected)
    classes.push("metadoc-page-thumbnails__item--selected");
  if (states.isFocused) classes.push("metadoc-page-thumbnails__item--focused");
  if (states.isDeleted) classes.push("metadoc-page-thumbnails__item--deleted");
  if (states.disabled) classes.push("metadoc-page-thumbnails__item--disabled");

  return classes.join(" ");
};
